import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import useNotif from 'hooks/use-notify-hook';
import { useLocalStorage } from 'react-use';
import { DateRange } from 'react-date-range';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from 'react-bootstrap';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import AuditeeWidget from './Widget/Auditee/Auditee';
import AuditorWidget from './Widget/Auditor/Auditor';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

export default function Edit() {

  const history = useHistory();

  const { scheduleId } = useParams();
  const [auth] = useLocalStorage('authenticated');
  const [swal, setSwal] = useAlert(null);
  const [notif, dispatchNotif] = useNotif();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisabledMember, setIsDisabledMember] = useState(true);
  const [scope, setScope] = useState(-1);
  const [scopes, setScopes] = useState([]);
  const [auditee, setAuditee] = useState(-1);
  const [auditees, setAuditees] = useState([]);
  const [instrument, setInstrument] = useState(-1);
  const [instruments, setInstruments] = useState([]);
  const [auditeeTeams, setAuditeeTeams] = useState([]);
  const [auditorTeams, setAuditorTeams] = useState([]);
  const [state, setState] = useState([{
    startDate: new Date(),
    endDate: null,
    key: 'selection'
  }]);

  const wellStyles = { maxWidth: 300, margin: 20 };
  const handleEdit = async () => {
    setIsDisabledMember(false);
  }
  const handleSave = async () => {
    setIsDisabledMember(true);
  }
  const handleSubmit = async () => {

    /** Validating input */
    switch (true) {
      case auditeeTeams.length <= 0:
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: `Validation Error`,
            message: `Auditee Team must be set`,
          }
        });
      case auditorTeams.length <= 0:
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: `Validation Error`,
            message: `Auditor Team must be set`,
          }
        });
      case !auditorTeams.some(auditor => auditor.AUDITOR_TYPE_ID === 2):
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: `Validation Error`,
            message: `Head of auditor must be set`,
          }
        });
      case state[0].endDate === null:
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: `Validation Error`,
            message: `Schedule date range must be set.`,
          }
        });
    }

    try {

      const onSuccessCallback = async () => {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedules/${scheduleId}/publish`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          }
        });

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Publish Success`,
            message: `Audit schedule successfuly published.`,
          }
        });

        history.push(`/admin/schedules`);
      }

      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure?`,
          message: `You wont be able to change this audit schedule after it published.`,
          onSuccess: {
            title: `Success`,
            message: `Delete Success`,
            callback: onSuccessCallback,
          }
        }
      });


    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }

  }

  const handleChangeDate = async item => {

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}schedules/${scheduleId}`,
        {
          START_DATE: moment(item.selection.startDate).format('DD-MM-YYYY'),
          END_DATE: moment(item.selection.endDate).format('DD-MM-YYYY'),
        },
        {headers: {Authorization: `Bearer ${auth.token}`}}
      );

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

      setState([item.selection]);

    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleChangeAuditee = async ({target: {value}}) => {

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}schedules/${scheduleId}`,
        {AUDITEE_ID: value},
        {headers: {Authorization: `Bearer ${auth.token}`}}
      );

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

      setAuditee(value);

    } catch (error)  {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleChangeInstrument = async ({ target: { value }}) => {

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}schedules/${scheduleId}`,
        { INSTRUMENT_ID: value },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          }
        }
      );

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

      setInstrument(value);

    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchScopes = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scopes`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: { all: true }
      });

      setScopes(response.data.items);

    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchAuditees = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}auditees`,
        {
          headers: {Authorization: `Bearer ${auth.token}`},
          params: {
            expand: 'department',
            SCOPE_ID: scope,
            all: true
          }
        }
      );

      setAuditees(response.data.items);

    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchInstruments = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_HOST}instruments`,
        {headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          expand: 'standard',
          INSTRUMENT_STATUS: 'PUBLISHED',
          all: true
        }
      });

      setInstruments(response.data.items);

    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const fetchSchedule = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedules/${scheduleId}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: 'auditee,instrument,auditeeTeams.employee.user,auditorTeams.auditor.employee.user',
        }
      });

      setInstrument(response.data.instrument.INSTRUMENT_ID);
      setScope(response.data.auditee.SCOPE_ID);
      setAuditee(response.data.auditee.AUDITEE_ID);
      setAuditeeTeams(response.data.auditeeTeams);
      setAuditorTeams(response.data.auditorTeams);
      setState([{
        startDate: response.data.START_DATE ? new Date(response.data.START_DATE) : new Date(),
        endDate: response.data.END_DATE ? new Date(response.data.END_DATE) : null,
        key: 'selection'
      }]);

      if (response.data.SCHEDULE_STATUS === 'DRAFT') {
        setIsDisabled(false);
        setIsDisabledMember(false);
      }

    } catch (error) {

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const handleSendEmail = async () => {
    try {
      const onSuccessCallback = async () => {
        let formData = new FormData();
        formData.append('TYPE', 'CREATE_AUDIT');
        formData.append('EMAIL', JSON.parse(localStorage.getItem('authenticated')).employee.EMP_EMAIL);
        formData.append('SCHEDULE', scheduleId);
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}notification/send-email`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          }
        });
      }
      setSwal({
        type: TYPES.CONFIRM,
        payload: {
          title: `Are you sure?`,
          message: `You are about to send Notification to Auditee Member.`,
          onSuccess: {
            title: `Success`,
            message: `Send Notification Success`,
            callback: onSuccessCallback,
          }
        }
      });
    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  useEffect(() => {
    fetchScopes();
    fetchInstruments();
    fetchSchedule();
  }, []);

  useEffect(() => {
    fetchAuditees();
  }, [scope]);

  return (
    <Container fluid>
      {swal}{notif}
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => history.push(`/admin/schedules`)}>
          Schedules
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Edit
        </Breadcrumb.Item>
      </Breadcrumb>

      <Form>
        <Row>
          <Col md="5">
            <Card>
              <Card.Body>
                <Form.Group>
                  <Form.Label>Scope</Form.Label>
                  <Form.Control
                    disabled={isDisabled}
                    as="select"
                    defaultValue={-1}
                    value={scope}
                    onChange={({target: {value}}) => {
                      setAuditee(-1);
                      setScope(value);
                    }}
                  >
                    <option disabled value={-1}>Please Select...</option>
                    {scopes && scopes.map((scope, key) => (
                      <option key={key} value={scope.SCOPE_ID}>{scope.SCOPE_NAME}</option>
                    ))}
                  </Form.Control>
                </Form.Group>

                <Form.Group>
                  <Form.Label>Auditee</Form.Label>
                  <Form.Control
                    disabled={isDisabled}
                    as="select"
                    defaultValue={-1}
                    value={auditee}
                    onChange={handleChangeAuditee}
                  >
                    <option disabled value={-1}>Please Select...</option>
                    {auditees && auditees.map((auditee, key) => (
                      <option key={key} value={auditee.AUDITEE_ID}>{auditee.department.DEPT_NAME}</option>
                    ))}
                  </Form.Control>
                </Form.Group>

                <Form.Group>
                  <Form.Label>Template</Form.Label>
                  <Form.Control
                    disabled={isDisabled}
                    as="select"
                    defaultValue={-1}
                    value={instrument}
                    onChange={handleChangeInstrument}
                  >
                    <option disabled value={-1}>Please Select...</option>
                    {instruments && instruments.map((instrument, key) => (
                      <option key={key} value={instrument.INSTRUMENT_ID}>{instrument.standard.STANDARD_NAME} - {instrument.INSTRUMENT_NAME}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Card.Body>
            </Card>
            <div class="btn-toolbar" role="toolbar">
              <Button type="button" onClick={handleEdit} variant="primary" >Edit Member</Button>
              &nbsp;
              &nbsp;
              <Button type="button" onClick={handleSave} variant="success" >Save Member</Button>
            </div>
            {/* Saya hapus karena admin ingin bisa mengubah data auditee atau auditor disabled={isDisabled} */}
            <AuditeeWidget disabled={isDisabledMember} auditeeTeams={auditeeTeams} onChange={setAuditeeTeams} />
            <AuditorWidget disabled={isDisabledMember} auditorTeams={auditorTeams} onChange={setAuditorTeams} />
          </Col>
          <Col md="7">
            <Card>
              <Card.Body>
                <Form.Group>
                  <Form.Label>Schedule</Form.Label>
                  {isDisabled
                    ? <div>{moment(state[0].startDate).format('DD MMMM YYYY')} - {moment(state[0].endDate).format('DD MMMM YYYY')}</div>
                    : (
                      <div>
                        <DateRange
                          editableDateInputs={true}
                          onChange={handleChangeDate}
                          moveRangeOnFirstSelection={false}
                          ranges={state}
                          months={2}
                          direction="horizontal"
                        />
                      </div>
                    )}
                </Form.Group>
                <div class="btn-toolbar" role="toolbar">
                  <Button type="button" onClick={handleSendEmail} variant="danger" >Send Notification</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {!isDisabled && (
          <Row style={{ justifyContent: 'flex-end' }}>
            <Col style={{ width: 'auto', flexGrow: 'unset', flexBasis: 'unset' }}>
              <Button onClick={handleSubmit} variant="success">Submit</Button>
            </Col>
          </Row>
        )}
      </Form>
    </Container>
  )
}